<template>
	<permits-item v-if="show" :color="'#03A9F4'">
		<div class="c1">
			<div class="icon"></div>
			<div>
				<h1>{{ $t('Location Service') }}</h1>
				<p>{{ $t('We need to know where you are in order to scan nearby you patients more easy.') }}</p>
			</div>
		</div>
		<template v-slot:footer>
			<action-button v-if="location.prompt" :color="'rgba(0,0,0,0.5)'" :title="$t('Enable location service')" @click="requestPermission"/>
			<action-button v-if="location.denied" :color="'rgba(0,0,0,0.5)'" :title="$t('Blocked. How to unlock?')" @click="howToUnlock"/>
			<action-button v-if="location.granted" :color="'rgba(0,0,0,0.5)'" :title="$t('Active location service')"/>
		</template>
	</permits-item>
</template>

<script>
import { mapGetters } from 'vuex'
import PermitsItem from '@/modules/permits/PermitsItem'
import ActionButton from '@/modules/ui/ActionButton'
export default {
	name: 'permits-item-location',
	components: {
		PermitsItem,
		ActionButton
	},
	methods: {
		async checksPermission() {
			const query = await navigator.permissions.query({name: 'geolocation'})

			if (query.state === 'prompt')
			{
				this.$store.dispatch('PUT_STATE_LOCATION', { granted: false, denied: false, prompt: true })
			}
			else if (query.state === 'denied')
			{
				this.$store.dispatch('PUT_STATE_LOCATION', { granted: false, denied: true, prompt: false })
			}
			else if (query.state === 'granted')
			{
				this.$store.dispatch('PUT_STATE_LOCATION', { granted: true, denied: false, prompt: false })
			}
		},
		requestPermission() {
			if (this.location.prompt) {
				navigator.geolocation.getCurrentPosition((position) => {
					this.checksPermission()
				}, () => {
					this.checksPermission()
				})
			}
		},
		howToUnlock() {
			this.$appModal.show({
				title: this.$t('How to Unlock'),
				message: this.$t('To unlock you must go browser settings to our app and change the location permission to "Ask" again.')
			})
		}
	},
	computed: {
		show() {
			return this.location.prompt || this.location.denied
		},
		...mapGetters({
			location: 'GET_LOCATIONS'
		})
	},
	created() {
		this.checksPermission()
	}
}
</script>

<style scoped>
.c1 {
	display: flex;
}
.icon {
	margin: 15px 0 0 10px;
	display: block;
	width: 50px;
	height: 50px;
	flex: 0 0 50px;
	background-image: url(/static/svg/buttons/maps-and-flags.svg);
	background-position: center;
	background-repeat: no-repeat;
	background-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/modules/permits/PermitsItemLocation.vue